import axios from "axios";

export default {
  getAll: (page, pageSize) => axios.get("/api/ditech-gateway/errors", { params: { page, pageSize }, headers: { Accept: "application/json" } }),
  setNote: (id, note) => axios.patch(`/api/ditech-gateway/errors/${id}`, {note})
}
